import { Filter, X } from "lucide-react";
import { FC } from "react";
import { useIntl } from "react-intl";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import { trackEvent } from "~/utils/analytics";

interface DocListFilterProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const DocListFilter: FC<DocListFilterProps> = ({
  searchTerm,
  setSearchTerm,
}) => {
  const intl = useIntl();

  return (
    <div className="flex w-full grow">
      <div className="flex-1 flex gap-1 relative">
        <Input
          placeholder={intl.formatMessage({
            id: "common.filter",
            defaultMessage: "Filter",
          })}
          onClick={() => {
            trackEvent({ eventName: "app/doc_list/filter.input/click" });
          }}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          className="pl-8"
          parentClassName="flex items-center w-full"
          iconBefore={
            <Filter className="w-4 h-4 flex-shrink-0 text-muted-foreground" />
          }
        />
        {searchTerm && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setSearchTerm("");
              trackEvent({
                eventName: "app/doc_list/filter_clear.button/click",
              });
            }}
            className="absolute right-0 hover:bg-transparent"
          >
            <X className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
